import { useModal, useModalSlot } from 'vue-final-modal'
import { RouterView } from 'vue-router'
import ModalFull from '@client/js/components/ModalFull.vue'
import router from '../routes'

let modalApi = null;

// function handleClose () {
//   _close()

//   if (returnTo) {
//     router.push(returnTo)          // normal open
//     returnTo = null
//   } else if (window.history.state && window.history.state.back !== null) {
//     router.back()                  // direct open when history exists
//   } else {
//     router.push('/')               // first open - go home url
//   }
// }

export function useCheckoutModal() {
  if (!modalApi) {
    const { open, close } = useModal({
      component: ModalFull,
      keepAlive: true,
      attrs: {
        onClose(e, d) {
            close()
            router.push('/')
        },
      },
      slots: {
        default: useModalSlot({
          component: RouterView,
        }),
      },
    })

    modalApi = { open, close }
  }

  return modalApi
}